import { t as _objectSpread2 } from "./objectSpread2-CtW7yo8J.js";
import { t as _objectWithoutProperties } from "./objectWithoutProperties-mN58NJZT.js";
import { t as Sidepanel } from "./Sidepanel-Azjylk9o.js";
import { SidepanelButton } from "./sidepanelButton.js";
import { DocSearch, useDocSearch } from "@docsearch/core";
import React from "react";
import { createPortal } from "react-dom";

//#region src/Sidepanel.tsx
const _excluded = [
	"keyboardShortcuts",
	"theme",
	"onReady",
	"onOpen",
	"onClose",
	"onSidepanelOpen",
	"onSidepanelClose"
];
const _excluded2 = ["portalContainer"];
const _excluded3 = ["button", "panel"];
function DocSearchSidepanelComponent(_ref, ref) {
	let { keyboardShortcuts, theme, onReady, onOpen, onClose, onSidepanelOpen, onSidepanelClose } = _ref, props = _objectWithoutProperties(_ref, _excluded);
	return /* @__PURE__ */ React.createElement(DocSearch, {
		appId: props.appId,
		apiKey: props.apiKey,
		keyboardShortcuts,
		theme,
		ref,
		onReady,
		onOpen,
		onClose,
		onSidepanelOpen,
		onSidepanelClose
	}, /* @__PURE__ */ React.createElement(DocSearchSidepanelComp, props));
}
const DocSearchSidepanel = React.forwardRef(DocSearchSidepanelComponent);
function DocSearchSidepanelComp(_ref2) {
	let { button: buttonProps = {}, panel: _ref3 = {} } = _ref2, { portalContainer } = _ref3, panelProps = _objectWithoutProperties(_ref3, _excluded2), rootProps = _objectWithoutProperties(_ref2, _excluded3);
	const { docsearchState, setDocsearchState, keyboardShortcuts, registerView, initialAskAiMessage, appId, apiKey } = useDocSearch();
	if (!appId || !apiKey) throw new Error("`Sidepanel` requires `appId` and `apiKey` props or values configured on the `DocSearch` provider.");
	const toggleSidepanelState = React.useCallback(() => {
		setDocsearchState(docsearchState === "sidepanel" ? "ready" : "sidepanel");
	}, [docsearchState, setDocsearchState]);
	const handleClose = () => {
		setDocsearchState("ready");
	};
	const handleOpen = () => {
		setDocsearchState("sidepanel");
	};
	const containerElement = React.useMemo(() => portalContainer !== null && portalContainer !== void 0 ? portalContainer : document.body, [portalContainer]);
	React.useEffect(() => {
		registerView("sidepanel");
	}, [registerView]);
	const ButtonComp = React.useMemo(() => /* @__PURE__ */ React.createElement(SidepanelButton, _objectSpread2({
		keyboardShortcuts,
		onClick: toggleSidepanelState
	}, buttonProps)), [
		keyboardShortcuts,
		toggleSidepanelState,
		buttonProps
	]);
	return /* @__PURE__ */ React.createElement(React.Fragment, null, buttonProps.variant === "inline" ? ButtonComp : createPortal(ButtonComp, containerElement), createPortal(/* @__PURE__ */ React.createElement(Sidepanel, _objectSpread2(_objectSpread2(_objectSpread2({
		initialMessage: initialAskAiMessage,
		isOpen: docsearchState === "sidepanel",
		onClose: handleClose,
		onOpen: handleOpen
	}, rootProps), panelProps), {}, { keyboardShortcuts })), containerElement));
}

//#endregion
export { DocSearchSidepanel, Sidepanel, SidepanelButton };
//# sourceMappingURL=sidepanel.js.map